import React from "react";
import "./testimonial.css";
import quote from "../Assets/icon.png";
import user1 from "../Assets/vishal.png";
import user2 from "../Assets/susnitha.png";

const testimonialsData = [
  {
    id: 1,
    name: "Vishal Kumar",
    text: "I visited Shri Adithya Hospitals for a cardiac consultation. The experience was seamless one from appointment booking to diagnosis and treatment planning. The team is not only experienced but also compassionate. I highly recommend them for anyone looking for quality care.",
    img: user1,
  },
  {
    id: 2,
    name: "Susnitha",
    text: "My mother was admitted for a medical emergency at Shri Adithya Hospitals. The emergency team of doctors acted swiftly kept us informed all throughout the process. We're grateful for the timely and life-saving care she received at their hospital.",
    img: user2,
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <h2 className="testimonials-title">Testimonials</h2>
      <p className="testimonials-subtitle">
        Hear from Those Who’ve Healed with Us
      </p>
      <div className="testimonials-wrapper">
        {testimonialsData.map((item) => (
          <div key={item.id} className="testimonial-card">
            <img src={quote} alt="quote" className="quote-img" />
            <p className="testimonial-text">“{item.text}”</p>
            <div className="testimonial-user">
              <img src={item.img} alt={item.name} className="user-img" />
              <h4 className="user-name">{item.name}</h4>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
